<template>
  <div class="poems-page">
    <h1 class="title">Poems</h1>

    <!-- Poem Section -->
    <section class="poems-section">
      <div class="poem" v-for="(poem, index) in poems" :key="index">
        <div class="poem-preview" @click="openModal(poem)">
          <p class="poem-title">{{ poem.title }}</p>
          <p class="poem-excerpt">{{ poem.excerpt }}</p>
        </div>
      </div>
    </section>

    <!-- Modal for Poems -->
    <div class="modal" v-if="isModalOpen" @click.self="closeModal">
      <div class="modal-content" ref="modalContent">
        <span class="close" @click="closeModal">&times;</span>
        <div v-if="currentPoem">
          <h2>{{ currentPoem.title }}</h2>
          <p class="poem-text" ref="poemText"></p>
          <button @click="prevPost" class="nav-button prev">&lt;</button>
          <button @click="nextPost" class="nav-button next">&gt;</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Hammer from 'hammerjs';

export default {
  name: 'PoemsPage',
  data() {
    return {
      isModalOpen: false,
      currentPoem: null,
      currentIndex: null,
      poems: [
  {
    title: 'The Girl I Loved',
    excerpt: 'A girl I loved once broke my heart...',
    fullText: `
      There once was a girl I adored,
      Her love left me broken and floored,
      Crimson tears did flow,
      In pain, I did know,
      Now her absence cannot be ignored.
    `
  },
  {
    title: 'Memories of My Mother',
    excerpt: 'I’ll always cherish the memories of my mother...',
    fullText: `
      Sweet memories of mother I hold,
      Her love in my heart will unfold,
      Though she's not here,
      Her memory's clear,
      In my dreams, her warmth I behold.
    `
  },
  {
    title: 'Greatness in God’s Name',
    excerpt: 'I will rise to be great in God’s name...',
    fullText: `
      In God's name, I strive to be great,
      With His love, I’ll conquer my fate,
      Through trials, I’ll fight,
      For His light so bright,
      In His glory, my fame will await.
    `
  },
  {
    title: 'Note to My Future Self',
    excerpt: 'A note to my future self, here’s what I say...',
    fullText: `
      A note to my future self, dear,
      Remember the dreams you hold near,
      Keep striving ahead,
      By hope, you'll be led,
      Embrace each moment, have no fear.
    `
  },
  {
    title: 'A Broken Heart’s Lament',
    excerpt: 'Crimson tears fall from my eyes...',
    fullText: `
      Crimson tears fall from my eyes,
      Her departure, my soul defies,
      In the shadows of night,
      I drown in my plight,
      With each memory, my heart cries.
    `
  },
  {
    title: 'The Warrior’s Pain',
    excerpt: 'With each battle, I feel the strain...',
    fullText: `
      With each battle, I feel the strain,
      Crimson blood flows, enduring pain,
      But with courage, I stand,
      My sword in my hand,
      Through agony, strength I sustain.
    `
  },
  {
    title: 'The Haunting Night',
    excerpt: 'In the night, I hear whispers of doom...',
    fullText: `
      In the night, I hear whispers of doom,
      Crimson shadows invade my room,
      With fear in my chest,
      I find no rest,
      Haunted dreams in the dark loom.
    `
  },
  {
    title: 'The Crimson Blade',
    excerpt: 'My blade is drenched in crimson hue...',
    fullText: `
      My blade is drenched in crimson hue,
      Through battles, my courage grew,
      Each swing and thrust,
      In blood and dust,
      My warrior’s heart, bold and true.
    `
  },
  {
    title: 'A Lost Love’s Pain',
    excerpt: 'In my heart, there’s a crimson stain...',
    fullText: `
      In my heart, there’s a crimson stain,
      Her departure left me in pain,
      Though time has passed,
      Memories last,
      Forever, her love will remain.
    `
  },
  {
    title: 'A Programmer’s Quest',
    excerpt: 'With lines of code, I build and test...',
    fullText: `
      With lines of code, I build and test,
      Debugging, I strive for the best,
      Logic and flow,
      In JavaScript's glow,
      In the world of bytes, I'm blessed.
    `
  },
  {
    title: 'The Debugging Knight',
    excerpt: 'In the night, I debug with might...',
    fullText: `
      In the night, I debug with might,
      Fixing bugs till morning light,
      With keyboard in hand,
      I take a stand,
      In the code, I find my fight.
    `
  },
  {
    title: 'The Infinite Loop',
    excerpt: 'Caught in an infinite loop of despair...',
    fullText: `
      Caught in an infinite loop of despair,
      My code runs, but goes nowhere,
      With logic askew,
      I start anew,
      Until the bug’s no longer there.
    `
  },
  {
    title: 'The Compiler’s Wrath',
    excerpt: 'The compiler’s wrath I do face...',
    fullText: `
      The compiler’s wrath I do face,
      Errors pop up, filling my space,
      With patience and grace,
      I find the right place,
      To make my code a perfect case.
    `
  },
  {
    title: 'The Code’s Redemption',
    excerpt: 'With persistence, my code is redeemed...',
    fullText: `
      With persistence, my code is redeemed,
      Logic flows like a perfect dream,
      Functions align,
      Variables shine,
      In the end, my program does gleam.
    `
  },
  {
    title: 'Whisky’s Warm Embrace',
    excerpt: 'A bottle of whisky, my solace at night...',
    fullText: `
      A bottle of whisky, my solace at night,
      In its warm embrace, I find light,
      Sips of gold,
      Stories told,
      In its depths, my worries take flight.
    `
  },
  {
    title: 'The Whisky’s Tale',
    excerpt: 'Each sip of whisky tells a tale...',
    fullText: `
      Each sip of whisky tells a tale,
      Of pirates, and ships that set sail,
      With courage and might,
      Through the darkest night,
      In its flavor, I will not fail.
    `
  },
  {
    title: 'A Toast to the Brave',
    excerpt: 'With whisky, I toast to the brave...',
    fullText: `
      With whisky, I toast to the brave,
      In its warmth, my spirit is saved,
      Through battles and strife,
      In this bold life,
      Each drop, a memory engraved.
    `
  },
  {
    title: 'Whisky and Wisdom',
    excerpt: 'With whisky, I ponder life’s scheme...',
    fullText: `
      With whisky, I ponder life’s scheme,
      In its amber glow, I do dream,
      Of paths I might take,
      Decisions I make,
      In its depths, wisdom’s supreme.
    `
  },
  {
    title: 'The Last Drop',
    excerpt: 'The last drop of whisky, I savor...',
    fullText: `
      The last drop of whisky, I savor,
      Its taste, a lingering favor,
      With a sigh and a smile,
      I rest for a while,
      In its warmth, I find my behavior.
    `
  }
      ]
    };
  },
  methods: {
    openModal(poem) {
      this.currentPoem = poem;
      this.currentIndex = this.poems.indexOf(poem);
      this.isModalOpen = true;
      this.$nextTick(() => {
        this.animatePoem();
        this.initializeSwipe();
      });
    },
    closeModal() {
      this.isModalOpen = false;
      this.currentPoem = null;
      this.currentIndex = null;
    },
    animatePoem() {
      const poemTextElement = this.$refs.poemText;
      const lines = this.currentPoem.fullText.split('\n');
      poemTextElement.innerHTML = '';

      lines.forEach((line, index) => {
        const span = document.createElement('span');
        span.innerHTML = line;
        span.style.display = 'block';
        span.style.opacity = 0;
        poemTextElement.appendChild(span);

        setTimeout(() => {
          span.style.transition = 'opacity 1s';
          span.style.opacity = 1;
        }, index * 1500); // Adjust delay for typing effect
      });
    },
    initializeSwipe() {
      const modalContent = this.$refs.modalContent;
      const hammer = new Hammer(modalContent);

      hammer.on('swipeleft', () => {
        this.nextPost();
      });

      hammer.on('swiperight', () => {
        this.prevPost();
      });
    },
    prevPost() {
      if (this.currentIndex > 0) {
        this.currentIndex--;
        this.currentPoem = this.poems[this.currentIndex];
        this.animatePoem();
      }
    },
    nextPost() {
      if (this.currentIndex < this.poems.length - 1) {
        this.currentIndex++;
        this.currentPoem = this.poems[this.currentIndex];
        this.animatePoem();
      }
    }
  }
}
</script>

<style scoped>
.poems-page {
  padding: 20px;
}

.title {
  text-align: center;
  font-size: 2rem;
  margin-bottom: 20px;
}

.poems-section {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
}

.poem {
  flex: 1 1 calc(50% - 20px);
  padding: 15px;
  border-radius: 5px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  cursor: pointer;
}

.poem-title {
  font-size: 1.2rem;
  margin-bottom: 10px;
}

.poem-excerpt {
  font-size: 1rem;
  color: #666;
}

.modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  backdrop-filter: blur(5px);
}

.modal-content {
  position: relative;
  max-width: 80%;
  max-height: 80%;
  padding: 20px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 1);
  border-radius: 5px;
  text-align: center;
  overflow: hidden;
}

.modal-content h2 {
  margin-bottom: 20px;
}

.poem-text {
  font-size: 1rem;
  line-height: 1.5;
}

.close {
  position: absolute;
  top: 10px;
  right: 10px;
  font-size: 24px;
  cursor: pointer;
}


.nav-button {
  background: rgba(0, 123, 255, 0.5); /* Adjust the alpha value (0.5) for transparency */
  border: none;
  color: white;
  padding: 10px;
  border-radius: 1px;
  cursor: pointer;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
}
.nav-button.prev {
  left: 0px;
}

.nav-button.next {
  right: 0px;
}
</style>
